import { useQuery } from '@tanstack/react-query';

import {
  getSubprojectInvitation,
  GetSubprojectInvitationInput,
} from '@/features/partners/api/get-subproject-invitation';

export const useGetSubprojectInvitation = ({
  invitationToken,
  enabled = true,
}: GetSubprojectInvitationInput & { enabled?: boolean }) => {
  return useQuery({
    queryKey: ['subproject-invitation', invitationToken],
    queryFn: () => getSubprojectInvitation({ invitationToken }),
    enabled: enabled && !!invitationToken,
  });
};
